import { render, staticRenderFns } from "./PanelCompetitionEdit.vue?vue&type=template&id=40cce9b2&scoped=true&"
import script from "./PanelCompetitionEdit.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionEdit.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionEdit.vue?vue&type=style&index=0&id=40cce9b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cce9b2",
  null
  
)

export default component.exports